<!-- <nb-card>
  <nb-card-header>
    <fa-icon icon="close" (click)="exit($event)" class="exit-icon"></fa-icon>
    <h3>{{ commentTitle }} {{ site.name }}</h3>
  </nb-card-header>
  <nb-card-body>
    @if (comments.length) {
      <table class="table workflow-comments-table">
        @for (comment of comments; track comment) {
          <tr
            class="comment-item"
            [ngClass]="isCommentSelected(comment) ? 'selected' : ''"
            >
            <td>{{ comment.comment_by }}</td>
            <td>{{ comment.comment_on | date : 'medium'}}</td>
            <td  class="comments-col" [innerHTML]="safeCommentText(comment)"></td>
            @if (canChange(comment)) {
              <td>
                <a href (click)="onEdit($event, comment)">
                  <fa-icon icon="pen"></fa-icon>
                </a>
              </td>
            }
            @if (canChange(comment)) {
              <td>
                <a href (click)="onDelete($event, comment)">
                  <fa-icon icon="trash"></fa-icon>
                </a>
              </td>
            }
          </tr>
        }
      </table>
    }
    @if (!hasForm() && canAddComment) {
      <div>
        <a href (click)="showForm($event)">{{ 'pages.workflow.comments.add-comment-link' | translate }}</a>
      </div>
    }
    @if (isFormVisible && canAddComment) {
      <div class="form-box">
        <textarea
          [(ngModel)]="newComment"
          class="form-control"
          [placeholder]="'pages.workflow.comments.add-comment-placeholder' | translate"
          required
        ></textarea>
        <app-comments></app-comments>
        <div class="btns-bar">
          <a href (click)="cancelComments($event)" class="btn btn-secondary">
            {{ 'pages.workflow.comments.add-comment-cancel' | translate }}
          </a>
          <a
            href
            (click)="postComments($event)"
            class="btn btn-primary"
            [ngClass]="newComment.length === 0 ? 'disabled' : ''"
            >
            {{ 'pages.workflow.comments.add-comment-ok' | translate }}
          </a>
        </div>
      </div>
    }
    @if (editedComment !== null) {
      <div class="form-box">
        <textarea
          [(ngModel)]="editedCommentText"
          class="form-control"
          required
          [disabled]="!canEditComment"
        ></textarea>
        <div class="btns-bar">
          <a href (click)="cancelComments($event)" class="btn btn-secondary">
            {{ 'pages.workflow.comments.add-comment-cancel' | translate }}
          </a>
          <a
            href
            (click)="patchComment($event)"
            class="btn btn-primary"
            [ngClass]="editedCommentText.length === 0 ? 'disabled' : ''"
            >
            {{ 'pages.workflow.comments.update-comment-ok' | translate }}
          </a>
        </div>
      </div>
    }
    @if (deletedComment !== null) {
      <div class="form-box">
        <div class="delete-comment-warning">
          {{ 'pages.workflow.comments.delete-comment-message' | translate }}
        </div>
        <div class="btns-bar">
          <a href (click)="cancelComments($event)" class="btn btn-secondary">
            {{ 'pages.workflow.comments.add-comment-cancel' | translate }}
          </a>
          <a
            href
            (click)="deleteComment($event)"
            class="btn btn-primary"
            >
            {{ 'pages.workflow.comments.delete-comment-ok' | translate }}
          </a>
        </div>
      </div>
    }
  </nb-card-body>
</nb-card> -->
<nb-chat size="medium" title="{{ commentTitle }} {{ site?.name }}"
         [noMessagesPlaceholder]="'No messages yet' | translate">
  <ng-template nbChatTitle let-data>
    <div>
      {{ commentTitle }} {{ site?.name }}

      {{ round?.name }} - {{ step?.name }}
      <fa-icon icon="close" (click)="exit($event)" class="exit-icon"></fa-icon>
    </div>
  </ng-template>
  <nb-chat-message *ngFor="let msg of comments" [type]="msg.type" [message]="msg.text" [reply]="msg.is_mine"
                   [sender]="msg.comment_by" [date]="msg.comment_on" [files]="null" [quote]="null">
  </nb-chat-message>
  <div ngProjectAs='nb-chat-form' class="p-2" data-test-id="nb-chat-form">
    <app-comments (content)="postComments($event)"
                  [canAddComment]="canAddComment"></app-comments>
  </div>
</nb-chat>

<ng-template #listMemberPopOver>
  <ul class="list-group list-group-flush">
    @for (member of step.managed_by.members; track member) {
      <li class="list-group-item">
        <fa-icon icon="user" class="me-2"></fa-icon>
        {{ member.first_name }} {{ member.last_name }}
      </li>
    }
  </ul>
</ng-template>
